<div>
	<div class="top-margin" fxLayout="row" fxLayoutAlign="center center">
		<div
			#popoverTrigger="mtxPopoverTrigger"
			[mtxPopoverTriggerFor]="laneFrequencyPopover"
			class="primary-text font-size-13 font-weight-bold m-t-1"
			fxFlex="65"
			fxFlexOffset="10"
			mtxPopoverTriggerOn="click"
			style="cursor: pointer"
		>
			Minimum Frequency
		</div>
		<mtx-popover #laneFrequencyPopover="mtxPopover" xOffset="100" [closeOnPanelClick]="false">
			<mat-card class="p-0">
				<mat-card-content>
					<div class="padding-0-5" fxLayout="row">
						Filter carriers based on the required volume for the load being searched.
					</div>
					<div class="padding-0-5" fxLayout="row">
						This filter can be used to limit search results to only those carriers that run a lane a
						minimum number of times per week.
					</div>
				</mat-card-content>
			</mat-card>
		</mtx-popover>
		<div fxFlex="25">
			<mat-form-field fxFlex="100">
				<input
					(input)="filterChanged()"
					[(ngModel)]="frequencyFilter.minLoadsPerWeek"
					autocomplete="off"
					matInput
					type="number"
				/>
			</mat-form-field>
		</div>
	</div>
	<!-- <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="0.5rem">
      <div fxFlex="30">
          <mat-checkbox [color]=" 'primary' " type="checkbox" (change)="filterChanged()" [(ngModel)]="frequencyFilter.sunday" name="sun">Sun</mat-checkbox>
      </div>
      <div fxFlex="30">
          <mat-checkbox [color]=" 'primary' " type="checkbox" (change)="filterChanged()" [(ngModel)]="frequencyFilter.monday" name="mon">Mon</mat-checkbox>
      </div>
      <div fxFlex="30">
          <mat-checkbox [color]=" 'primary' " type="checkbox" (change)="filterChanged()" [(ngModel)]="frequencyFilter.tuesday" name="tue">Tue</mat-checkbox>
      </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="0.5rem">
      <div fxFlex="30">
          <mat-checkbox [color]=" 'primary' " type="checkbox" (change)="filterChanged()" [(ngModel)]="frequencyFilter.wednesday" name="wed">Wed</mat-checkbox>
      </div>
      <div fxFlex="30">
          <mat-checkbox [color]=" 'primary' " type="checkbox" (change)="filterChanged()" [(ngModel)]="frequencyFilter.thursday" name="thu">Thu</mat-checkbox>
      </div>
      <div fxFlex="30">
          <mat-checkbox [color]=" 'primary' " type="checkbox" (change)="filterChanged()" [(ngModel)]="frequencyFilter.friday" name="fri">Fri</mat-checkbox>
      </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="0.5rem">
      <div fxFlex="30">
          <mat-checkbox [color]=" 'primary' " type="checkbox" (change)="filterChanged()" [(ngModel)]="frequencyFilter.saturday" name="sat">Sat</mat-checkbox>
      </div>
      <div fxFlex="30"></div>
      <div fxFlex="30"></div>
  </div> -->
</div>
